export default __webpack_public_path__ + "static/media/CSSLogo.930d3a79.png";